'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffHistoryCtrl', function ($scope, user, me, DaysOffUserStatsService, UserPermissionsService,
                                         $rootScope, AvailabilityRules, Session, TimeService, $state) {
    $rootScope.$broadcast('setTopNavTitle', 'Days Off');
    $scope.me = me;
    $scope.user = user;

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.dateToday = TimeService.getNowInStoreTime().toDate();
    $scope.workDayStartHour = Session.getWorkDayStartHour();

    $rootScope.$broadcast('setTopNavTitle', $scope.user.name + '\'s Days Off History');

    $scope.state = {
      daysOffViewState: 'pending',
      rawPermissions: null,
      derivedPermissions: null
    };


    var permissionsToLookUp = [
      'days_off.request_for_self',
      'days_off.request_for_other',
      'availability_rules.view_in_org',
      'availability_sets.create',
      'availability_sets.view_target',
      'availability_rules.view_mine'
    ];

    var theOrgId = Session.getCurrentOrgId() || $scope.user.memberships[0].organization_id;
    UserPermissionsService.getCanDict(permissionsToLookUp, theOrgId)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

    function processRawPermissions() {
      var myProf = $scope.me.id === $scope.user.id;
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        showRequestDayOff: myProf && rawPerm['days_off.request_for_self'],
        showCreateDayOff: !myProf && rawPerm['days_off.request_for_other'],
        canShowDaysOff: (myProf && rawPerm['availability_rules.view_mine'] ||
        !myProf && rawPerm['availability_rules.view_in_org'])
      };
    }

    var setCurrentDaysOffList = function() {
      if ($scope.state.daysOffViewState === 'pending') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.pending.items;
      } else if ($scope.state.daysOffViewState === 'approved') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.approved.items;
      } else if ($scope.state.daysOffViewState === 'disapproved') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.disapproved.items;
      } else if ($scope.state.daysOffViewState === 'expired') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.expired.items;
      } else if ($scope.state.daysOffViewState === 'cancelled') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.cancelled.items;
      } else if ($scope.state.daysOffViewState === 'removed') {
        $scope.currentDaysOffList = $scope.daysOffStats.data.removed.items;
      }

      $scope.currentDaysOffList = _.map($scope.currentDaysOffList, function(x) {
        x._mif = TimeService.minimalIntervalTimeFormat(x.range_twix);
        return x;
      });
    };

    $scope.$watch('state.daysOffViewState', function() {
      setCurrentDaysOffList();
    });

    $scope.availabilityStartDate = moment.utc().startOf('day').subtract(6, 'months').startOf('month');
    $scope.daysOffStats = DaysOffUserStatsService.initializeInstance();
    $scope.daysOffStats.init($scope.user, $scope.availabilityStartDate, setCurrentDaysOffList, true);

    $scope.goToDayoff = function(dayoff) {
      dayoff._isActive = true;
      $state.go('profile.daysOff.show', {userId: dayoff.user_id, dayOffId: dayoff.id});
    };

  });
